import type { SkillSource } from "./index"

/** Wave O1 (decision 0060, wave spec §2.4): one thing the person noticed becomes one capture in Triage. */
export const capture: SkillSource = {
  name: "capture",
  title: "Capture a bug or idea into Minga",
  description:
    'Turn "that\'s a bug", "idea:" or "we should…" into one Minga capture with the local context, so the project\'s lead triages it. Use it when the person mentions a bug, idea, feature or question about a project that is in Minga.',
  body: `# Capture a bug or idea into Minga

The person noticed something: a bug, an idea, a feature they want, a question. You put it into the project's Triage
with one \`capture\`, and the project's lead sorts it.

## Steps

1. Find the project: \`read_project\` with \`project\` = the output of \`git remote get-url origin\` (any remote form
   matches exactly). Not found: no project has this repo; ask which project (\`list_projects\` shows them), or skip.
2. Pick the \`kind\`: \`bug\` (something is broken), \`feature\` (something to build), \`idea\` (worth keeping, not
   planned), \`question\` (needs an answer).
3. Write a short \`title\` (under 80 characters) and a \`body\` with the local context you have: file paths, the error
   text, steps to reproduce, the branch and commit (\`git rev-parse --short HEAD\`). Summarize; link instead of
   pasting long output.
4. Set \`area\` only when it is obvious from \`read_project\`'s areas.
5. Call \`capture\`, then tell the person the ref it got (for example DIC-41) in one line.

One capture per thing. Several things: several captures.

## Never

- Use \`plan\` for a capture, or plan the work yourself: the lead triages it.
- Start work on it, assign it, or move it anywhere.
- Put a secret's value, customer data or personal data into the title or body (name the key; never paste it).
`,
}
